import styled, {keyframes, css} from 'styled-components';

export const GrowMainWrap = styled.span(
  props => `
        width: 35%;
        display: flex;
        flex-direction: column;
        overflow:hidden;

        @media(max-width:1023px){
            width:100%;
            max-width:90%;
            margin:0 auto;
            margin-top:3rem;
            align-items: center;
        }

        @media(min-width: 1024px and max-width:1350px){
            width:50%;
        }
    `,
);

export const GrowHeadText = styled.h3(
  props => `
        font-size: 4.5rem;
        color: ${props.theme.colors.white.base};
        font-weight: 100;
        span{
            font-weight: 900;
        }

        @media(max-width:1023px){
            font-size: 2.4rem;
            text-align: center;
        }
    `,
);

export const GrowSubText = styled.p(
  props => `
        font-size: 1.6rem;
        color: #ffffff;
        line-height: 1.5;
        padding-top: 1.5rem;

        @media(max-width:1023px){
            font-size: 1.4rem;
            text-align: center;
        }
    `,
);

export const GrowTileWrap = styled.div(
  props => `
        width:100%;
        display: flex;
        flex-direction: column;
        margin-top:4rem;

        @media(max-width:1023px){
            align-items: center;
        }
    `,
);

export const GrowTile = styled.div(
  props => `
        display: flex;
        background-color: rgba(255,255,255,0.2);
        padding: .8rem;
        border-radius: 2rem;
        width:33rem;
        margin-bottom: 1.5rem;
        align-items: center;

        @media(max-width:1023px){
            width:32rem;
        }
    `,
);

export const TileCircle = styled.div(
  props => `
        width:1.6rem;
        height:1.6rem;
        border-radius: 50%;
        display: flex;
        position:relative;
        border:1px solid rgba(255,255,255,0.2);
        margin-right: 1rem;

        span{
            position: absolute;
            top:0.3rem;
            left:0.3rem;
            width:0.8rem;
            height:0.8rem;
            border-radius: 50%;
            background-color: #ffffff;
        }
    `,
);

export const GrowTileText = styled.p(
  props => `
        font-size: 1.6rem;
        color: #ffffff;
        span{
            font-weight: 900;
        }
    `,
);

export const GrowScrollWrap = styled.div(
  props => `
        width:100%;
        display: flex;
        align-items: center;
        margin-top:5rem;

        @media(max-width:1023px){
            margin-top:2.5rem;
            justify-content: center;
        }
    `,
);

export const GrowScrollBig = styled.div(
  props => `
        width:10rem;
        height:0.5rem;
        background-color: rgba(255,255,255,0.2);
        margin-left: 0.75rem;
        position: relative;
        border-radius: 2rem;
        span{
            background-color: #fff;
            border-radius: 2rem;
            position: absolute;
            top:0;
            left:0;
            width:8rem;
            height: 0.5rem;
        }
    `,
);

export const GrowScroll = styled.div(
  props => `
        width: 2rem;
        height: 0.5rem;
        background-color: rgba(255,255,255,0.2);
        margin-left: 0.75rem;
        border-radius: 2rem;
    `,
);

export const SliderCaroWrap = styled.div(
  props => `
        position: relative;
        width: 100%;
        height: 21rem;
        @media(max-width:1023px){
            height:14rem;
        }
    `,
);

export const SiderAnimation = keyframes`
    0%, 25%, 100%{left: 0}
    // 30%, 55%{left: -100%}
    // 60%, 85%{left: -200%}
`;

export const SliderInnerWrap = styled.div(
  props => css`
    position: absolute;
    width: 300%;
    top: 0;
    left: 0;
    overflow: hidden;
    animation: ${SiderAnimation} 26s infinite;
  `,
);

export const SlideWrap = styled.div(
  props => `
        position: relative;
        width: 33.33333333%;
        height: 100%;
        float: left;
        overflow: hidden
    `,
);

export const SlideWrapUae = styled.div(
  props => `
        position: relative;
        height: 100%;
        float: left;
        overflow: hidden
    `,
);
